<script setup lang="ts">
// Models
import { Employee } from '../../models/employee'

// Data
defineProps<{
  employee: Employee
  selected: boolean
  disabled?: boolean
}>()
defineEmits([
    'add-employee',
    'remove-employee',
])
</script>

<template>
  <li
    class="h-32 relative col-span-1 flex flex-col rounded-md bg-white text-center border border-gray-100"
    :class="[selected ? 'border-primary border-2' : '', disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:shadow']"
    @click="selected ? $emit('remove-employee', employee) : $emit('add-employee', employee)"
  >
    <div
      v-if="false"
      class="absolute top-2 left-2 w-2 h-2 rounded-full"
      :class="[
        'booked' === 'booked' ? 'bg-blue-400' : '',
        'available' === 'available' ? 'bg-green-400' : '',
        'busy' === 'busy' ? 'bg-red-400' : '',
        'time-off' === 'time-off' ? 'bg-yellow-400' : '',
        'unknown' === 'unknown' ? 'bg-gray-400' : '',
      ]"
    />
    <div class="flex flex-1 flex-col p-2">
      <img
        class="mx-auto h-16 w-16 shrink-0 rounded-full"
        :src="employee.avatarUrl"
        alt=""
      >
      <h3 class="mt-2 text-sm font-medium text-gray-900">
        {{ employee.firstName }} {{ employee.lastName }}
      </h3>
    </div>
  </li>
</template>